import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import {
  ComposeSocialMediaPost,
  ComposeSocialMediaPrefill
} from 'apps/wrapper/src/components/shared/patient-feedback/dialogs/compose-social-media-post/compose-social-media-post';
import { EventComposeSocialMedia } from 'apps/wrapper/src/types/event-bus';
import { useEffect, useRef, useState } from 'react';

export const ComposeSocialMediaEventListener = () => {
  const { listen } = useEventBus();
  const [composeState, setComposeState] = useState<EventComposeSocialMedia['data'] | null>(null);
  // Incremented on each event to force a fresh component mount via React key
  const composeKeyRef = useRef(0);
  const [composeKey, setComposeKey] = useState(0);

  useEffect(
    () =>
      listen('composeSocialMedia', (event: any) => {
        const data = (event as EventComposeSocialMedia).data;
        const prefill: ComposeSocialMediaPrefill | undefined = data.prefill
          ? {
              ...data.prefill,
              scheduledDate: data.prefill.scheduledDate ? new Date(data.prefill.scheduledDate) : null
            }
          : undefined;

        composeKeyRef.current += 1;
        setComposeKey(composeKeyRef.current);
        setComposeState({ ...data, prefill });
      }),
    [listen]
  );

  if (!composeState) return null;

  return (
    <ComposeSocialMediaPost
      key={composeKey}
      open={true}
      locationId={composeState.locationId}
      mode={composeState.mode}
      prefill={composeState.prefill as ComposeSocialMediaPrefill | undefined}
      socialMediaType="Facebook"
      review={null}
      onClose={() => setComposeState(null)}
      onPostSend={async () => setComposeState(null)}
    />
  );
};
